import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Import components
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import GallerySection from './components/GallerySection';
import InstagramReelsSection from './components/InstagramReelsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import AllTestimonialsPage from './components/AllTestimonialsPage';

const Home = () => {
  return (
    <div className="min-h-screen bg-page">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <TestimonialsSection />
        <GallerySection />
        <InstagramReelsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/testimonios" element={<AllTestimonialsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
